export default __webpack_public_path__ + "static/media/grayTick.7d42c396.svg";